import React, { useState, useEffect } from 'react';
import useStyles from './styles';
import { TextField, Button, Typography, Paper, form } from '@material-ui/core';
import FileBase from 'react-file-base64';
import { useDispatch, useSelector } from 'react-redux';
import { createPost, updatePost } from '../../actions/posts';

const Form = ({ currentId, setCurrentId }) => {
	const classes = useStyles();
	const post = useSelector((state) => (currentId ? state.posts.find((p) => p._id === currentId) : null));
	const [postData, setPostData] = useState({
		title: '',
		message: '',
		tags: '',
		selectedFile: '',
	});

	console.log(postData);

	useEffect(() => {
		if (post) {
			setPostData(post);
		}
	}, [post]);

	const dispatch = useDispatch();

	const clear = () => {
		setCurrentId(null);
		setPostData({
			title: '',
			message: '',
			tags: '',
			selectedFile: '',
		});
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log('clicked');
		if (currentId) {
			dispatch(
				updatePost(currentId, { ...postData, name: JSON.parse(localStorage.getItem('profile'))?.result.name })
			);
		} else {
			dispatch(createPost({ ...postData, name: JSON.parse(localStorage.getItem('profile'))?.result.name }));
		}
		clear();
	};

	if (!localStorage.getItem('profile')) {
		return (
			<Paper className={classes.paper}>
				<Typography variant="h6" align="center">
					Please Sign in to create your own memories
				</Typography>
			</Paper>
		);
	}

	return (
		<Paper className={classes.paper}>
			<form autoComplete="off" noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
				<Typography variant="h6">{currentId ? 'Editing a Memory' : 'Creating a Memory'}</Typography>

				<TextField
					name="title"
					variant="outlined"
					label="title"
					fullWidth
					value={postData.title}
					onChange={(e) => setPostData({ ...postData, title: e.target.value })}
				/>
				<TextField
					name="message"
					variant="outlined"
					label="message"
					fullWidth
					value={postData.message}
					onChange={(e) => setPostData({ ...postData, message: e.target.value })}
				/>
				<TextField
					name="tags"
					variant="outlined"
					label="tags (coma separated)"
					fullWidth
					value={postData.tags}
					onChange={(e) => setPostData({ ...postData, tags: e.target.value.split(',') })}
				/>

				<div className={classes.fileInput}>
					<FileBase
						type="File"
						multiple={false}
						onDone={({ base64 }) => setPostData({ ...postData, selectedFile: base64 })}
					/>
				</div>

				<Button
					className={classes.buttonSubmit}
					variant="contained"
					color="primary"
					size="large"
					type="submit"
					fullWidth
				>
					Submit
				</Button>
				<Button variant="contained" color="secondary" size="small" fullWidth onClick={clear}>
					Clear
				</Button>
			</form>
		</Paper>
	);
};

export default Form;
